
export interface Toast{
    key?:string
    type:string
    message:string
};

class ToastService{

    _cb = (toast:Toast)=>{};

    setCallback(cb:(toast:Toast)=>void){ this._cb = cb; }

    showToast(t:Toast){
        this._cb && this._cb(t);
    }

}

export const toastService = new ToastService();
